import { Link } from "react-router-dom";

import { IMAGE_PATHS } from "@/shared/constants/assets-path";
import PopUpModal from "@/shared/ui/modal/pop-up";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.kindergarten.onebyone.one_by_one&pcampaignid=web_share&pli=1";
const APP_STORE_URL =
  "https://apps.apple.com/kr/app/%EC%9B%90%EB%B0%94%EC%9B%90/id6744432824";

export default function WebEntryAlert({ isOpen }: WebEntryAlertProps) {
  return (
    <PopUpModal
      isOpen={isOpen}
      hasCloseButton={false}
      closeOnOverlayClick={false}
      className="text-center"
      title=" "
      footer={
        <div className="flex w-full flex-col items-center gap-3 px-3 pb-3 pt-2.5">
          <Link
            to={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full max-w-52"
          >
            <img
              src={IMAGE_PATHS.DIRECT.PLAYSTORE}
              alt="Play Store에서 원바원 다운로드"
              className="block h-auto w-full object-contain"
            />
          </Link>
          <Link
            to={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full max-w-52"
          >
            <img
              src={IMAGE_PATHS.DIRECT.APPSTORE}
              alt="App Store에서 원바원 다운로드"
              className="block h-auto w-full object-contain"
            />
          </Link>
          <p className="text-xs tracking-tight text-primary-normal03">
            웹에서는 서비스를 이용할 수 없어요.
          </p>
        </div>
      }
    >
      <div className="flex flex-col items-center gap-9 px-5">
        <p className="text-left text-xl tracking-tighter text-primary">
          <span className="font-semibold">원바원 앱</span>에서 더 편리하게 많은
          기능을 이용해보세요!
        </p>
        <img
          src={IMAGE_PATHS.LANDING.APP}
          alt="원바원 앱 랜딩 이미지"
          className="block h-auto w-44 object-contain sm:max-w-[240px]"
        />
      </div>
    </PopUpModal>
  );
}

interface WebEntryAlertProps {
  isOpen: boolean;
}
